module.exports = __webpack_public_path__ + "static/media/placement.f320c064.svg";